import React, { useEffect, useMemo, useState } from "react";
import Chips from "components/Chips";
import {
  Typography,
  Stack,
  Accordion,
  AccordionDetails,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomAccordionSummary from "styles/customAccordionSummary";
import Api from "api";

export default function QuickFilters({
  activeQuarter,
  quarterActiveFilter,
  setQuarterActiveFilter,
  adoptedActiveFilter,
  setAdoptedActiveFilter,
  handleAccordionToggle,
  updateLocalStorageForFilter,
  resetFilter,
}) {
  const [expanded, setExpanded] = useState(false);

  const [adoptionOptions, setAdoptionOptions] = useState([
    { label: "All", selected: false, value: "" },
  ]);

  useEffect(() => {
    const fetchAdoptionOptions = async () => {
      try {
        const { data } =
          await Api.policyEnforcementGrid.getAllAdoptionOptions();

        const mapped = data.map((dto) => ({
          label: dto.statusDescription || dto.statusCode,
          selected: false,
          value: dto.statusDescription,
        }));
        setAdoptionOptions([
          { label: "All", selected: false, value: "" },
          ...mapped,
        ]);
      } catch (err) {
        setAdoptionOptions([{ label: "All", selected: false, value: "" }]);
      }
    };

    fetchAdoptionOptions();
  }, []);

  const getLastQuarter = () => {
    if (activeQuarter === 1) {
      return "Q4";
    } else {
      return `Q${activeQuarter - 1}`;
    }
  };
  const getNextQuarter = () => {
    if (activeQuarter === 4) {
      return "Q1";
    } else {
      return `Q${activeQuarter + 1}`;
    }
  };
  const quarter = useMemo(
    () => [
      { label: "All", selected: false, value: "" },
      { label: "Last quarter", selected: false, value: getLastQuarter() },
      { label: "This quarter", selected: false, value: `Q${activeQuarter}` },
      { label: "Next quarter", selected: false, value: getNextQuarter() },
    ],
    [activeQuarter]
  );

  const handleResetFilters = () => {
    resetFilter();
  };

  const handleAccordionChange = () => {
    setExpanded(!expanded);
    handleAccordionToggle();
  };

  const isResetVisible =
    quarterActiveFilter !== "" || adoptedActiveFilter !== "";

  return (
    <div>
      <Accordion expanded={expanded} onChange={handleAccordionChange}>
        <CustomAccordionSummary
          sx={{ margin: "2px" }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ mb: 0 }}
            px={(theme) => theme.spacing(1)}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Quick Filters:
            </Typography>
            {isResetVisible && (
              <Button onClick={handleResetFilters} color={"selectedChip"}>
                Reset
              </Button>
            )}
            {/* Display selected filters only when the accordion is collapsed */}
            {!expanded && quarterActiveFilter !== "" ? (
              <Typography variant="body2">
                <span style={{ fontWeight: "bold" }}>By Quarter:</span>{" "}
                {quarterActiveFilter}
              </Typography>
            ) : null}
            {!expanded && adoptedActiveFilter !== "" ? (
              <Typography variant="body2">
                <span style={{ fontWeight: "bold" }}>
                  By Adoption Decision:
                </span>{" "}
                {adoptedActiveFilter}
              </Typography>
            ) : null}
          </Stack>
        </CustomAccordionSummary>
        <AccordionDetails>
          <Stack
            direction="row"
            spacing={1}
            sx={{ mb: 1, flexWrap: "wrap", rowGap: 1 }}
          >
            <Typography
              variant="subtitle1"
              sx={{ width: 200, fontWeight: "bold" }}
            >
              By Quarter:
            </Typography>
            <Chips
              values={quarter}
              activeFilter={quarterActiveFilter}
              selectedFilter={(data) => {
                setQuarterActiveFilter(data.value);
                updateLocalStorageForFilter("quarter", data.value);
              }}
            />
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            sx={{ mb: 1, flexWrap: "wrap", rowGap: 1 }}
          >
            <Typography
              variant="subtitle1"
              sx={{ width: 200, fontWeight: "bold" }}
            >
              By Adoption Decision:
            </Typography>
            <Chips
              values={adoptionOptions}
              activeFilter={adoptedActiveFilter}
              selectedFilter={(data) => {
                setAdoptedActiveFilter(data.value);
                updateLocalStorageForFilter("adoption", data.value);
              }}
            />
          </Stack>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
